import Layout from '../layout'
import List from './list'
import Editor from './editor'

const basePath = '/v-admin/crm-management/task'

export default {
  path: `${basePath}/list`,
  component: Layout,
  meta: {
    titleI18nKey: 'admin.crm.title.tag.task',
    menu: {
      labelI18nKey: 'admin.crm.menu.task'
    },
    permission: ['PERM_TAG_MANAGEMANT', 'PREMIUM_TAG_MANAGEMENT']
  },
  children: [
    {
      name: 'tagTaskList',
      path: '',
      component: List,
      meta: {
        titleI18nKey: 'admin.crm.title.tag.task',
        breadcrumb: { hidden: true }
      }
    },
    {
      name: 'tagTaskAdd',
      path: `${basePath}/add`,
      component: Editor,
      meta: {
        titleI18nKey: 'admin.crm.title.tag.addTask'
      }
    },
    {
      name: 'tagTaskEdit',
      path: `${basePath}/edit/:taskId`,
      component: Editor,
      meta: {
        titleI18nKey: 'admin.crm.title.tag.editTask',
        isEditMode: true
      }
    }
  ]

}
